import { useNavigate } from 'react-router-dom';
import { Stack, Link, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { OutlineButton } from 'shared-components/Buttons/Outline';
import PKDHeader from 'components/Home/Header';
import ResearchImage from 'images/research.png';
import { getStyles } from './styles';

const NoPkd = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box>
      <PKDHeader />
      <Box
        sx={styles.mainContainer}>
        <Stack
          sx={styles.stack}>
          <Box>
            <img
              alt='overview'
              src={ResearchImage}
              maxWidth='522px'
              maxHeight='195px'
              style={styles.img}
            />
          </Box>
          <Box
            sx={{ padding: '20px 0px 0px 10px' }}>
            <Box
              sx={styles.title}>Thank you for your interest</Box>
            <Box
              sx={styles.text}>
              This Registry is intended for individuals with a diagnosis of
              ADPKD. If you are a caregiver, unaffected family member, friend or
              are otherwise engaged with PKD, please visit{' '}
              <Link
                href='https://pkdcure.org/'>PKD Connect</Link> to find other
              ways to get involved. For questions, please email{' '}
              <Link
                href='mailto:registry@pkdcure.org'>
                registry@pkdcure.org.
              </Link>
            </Box>
            <Box
              sx={styles.text}>
              At this point of time, you are not eligible to participant in the
              registry. Please access our website, PKD Foundation at{' '}
              <Link
                href='https://pkdcure.org/'>https://pkdcure.org/</Link> to
              find other ways you can support the foundation.
            </Box>
            <Box
              sx={styles.btnContainer}>
              <OutlineButton
                width='224px'
                height='40px'
                fontFamily='Montserrat'
                color={theme.palette.primary.blue1}
                borderColor={theme.palette.primary.blue1}
                text='Exit'
                onClickHandler={() => navigate('/')}
              />
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default NoPkd;
